const apiConfig = {
  'review-reasoner': {
    type: 'proxy',
    path_pattern: new RegExp('^/gateway/api/v1/reasoner(?:/.*)?$'),
    methods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'OPTIONS'],
    upstream_services: [
      {
        host: 'review-reasoner',
        port: 80,
        scheme: 'http',
      },
    ],
    strip_path: false,
    preserve_host: false,
    timeout: 30,
    health_check_path: '/health',
    require_auth: true,
    priority: 10,
    encryption: {
      enabled: true,
      patterns: [
        {
          methods: ['POST'],
          direction: 'both',
          path_pattern: new RegExp('^/gateway/api/v1/reasoner/projects/[a-zA-Z0-9_-]+/chat$'),
        },
        {
          methods: ['GET'],
          direction: 'both',
          path_pattern: new RegExp('^/gateway/api/v1/reasoner/projects/[a-zA-Z0-9_-]+/threads$'),
        },
        {
          methods: ['GET'],
          direction: 'response',
          path_pattern: new RegExp(
            '^/gateway/api/v1/reasoner/projects/[a-zA-Z0-9_-]+/threads/[a-zA-Z0-9_-]+$'
          ),
        },
        {
          methods: ['PUT'],
          direction: 'request',
          path_pattern: new RegExp(
            '^/gateway/api/v1/reasoner/projects/[a-zA-Z0-9_-]+/threads/[a-zA-Z0-9_-]+$'
          ),
        },
        {
          methods: ['GET'],
          direction: 'response',
          path_pattern: new RegExp(
            '^/gateway/api/v1/reasoner/projects/[a-zA-Z0-9_-]+/threads/[a-zA-Z0-9_-]+/messages$'
          ),
        },
      ],
    },
  },
  'review-api': {
    type: 'proxy',
    path_pattern: new RegExp('^/gateway/.*$'),
    methods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'OPTIONS'],
    upstream_services: [
      {
        host: 'review-api',
        port: 80,
        scheme: 'http',
      },
    ],
    strip_path: false,
    preserve_host: false,
    timeout: 30,
    health_check_path: '/health',
    require_auth: true,
    priority: 999,
    encryption: {
      enabled: true,
      patterns: [
        {
          methods: ['GET'],
          direction: 'response',
          path_pattern: new RegExp(
            '^/gateway/api/v1/projects/[a-zA-Z0-9_-]+/files/[a-zA-Z0-9_-]+$'
          ),
        },
      ],
    },
  },
  'graph-api': {
    type: 'internal',
    path_pattern: new RegExp('^/gateway/api/v1/graph/query$'),
    methods: ['POST'],
    require_auth: true,
    priority: 20,
    encryption: {
      enabled: true,
      patterns: [
        {
          methods: ['POST'],
          direction: 'both',
          path_pattern: new RegExp('^/gateway/api/v1/graph/query$'),
        },
      ],
    },
  },
};

export default apiConfig;
